import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "18",
        viewBox: "0 0 12 14",
        style: {
            fill: "none"
        }
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.8648 5.43914C10.8648 8.68414 8.96323 11.6696 5.9324 13C2.98594 11.702 1 8.76851 1 5.43914V3.04433L5.9324 1L10.8648 3.04433V5.43914Z",
            stroke: "#5155F6",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
export default Icon;
